<template>
  <AppForm label="配信対象者">
    <v-checkbox
      v-for="targetItem in targetList"
      :key="targetItem.value"
      :disabled="disabled || targetItem.disabled"
      v-model="targetCode"
      :value="targetItem.value"
    >
      <template v-slot:label>
        <span
          v-text="targetItem.text"
          v-bind:class="{ mention: targetItem.disabled }"
        />
      </template>
    </v-checkbox>
  </AppForm>
</template>

<script>
import AppForm from '@/components/App/AppForm'

/**
 * キャンペーンで設定できる項目をコピーしてシミュレーションでも使う
 * という関係性からキャンペーンからのimportを許容する
 */
import { MenuTargets } from '@/models/CampaignOperation/Constants'

export default {
  name: 'AppDeliveryTargetSetting',
  components: {
    AppForm,
  },
  props: {
    menuSetting: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    targetCode: {
      get() {
        return this.menuSetting.targetCode
      },
      set(value) {
        return this.menuSetting.setTargetCode(value)
      },
    },
    targetList() {
      return [
        { text: '訪問者', value: MenuTargets.VISITOR, disabled: false },
        { text: '居住者', value: MenuTargets.RESIDENT, disabled: false },
      ]
    },
  },
}
</script>

<style scoped>
/* AppFormのスタイルを打ち消す*/
::v-deep .title {
  min-width: 0;
}
</style>
